<script>
    export let icon = "ℹ️";
    export let title = "Message Title";
    export let content = "Message content goes here.";
    export let datetime = new Date().toLocaleString();
    export let isUnread = false;
    export let callToAction = null;
    export let onCallToAction = () => {};
    export let reply = false;
    export let onReply = () => {};
    export let onDelete = () => {};
  </script>
  
  <div
    class="flex flex-col p-4 rounded-lg space-y-2 border"
    class:border-[var(--app-primary-color)]={isUnread}
    class:border-[var(--app-border-color)]={!isUnread}
    style="background-color: var(--app-background-color); color: var(--app-text-color);"
  >
    <div class="flex items-start space-x-4">
      <div class="text-2xl">{icon}</div>
      <div class="flex-1">
        <p class="text-sm text-gray-400">{datetime}</p>
        <h3 class="text-lg font-bold" style="color: var(--app-primary-color);">{title}</h3>
        <p>{content}</p>
      </div>
    </div>
    <div class="flex justify-end space-x-4">
      <button
        on:click={onDelete}
        class="px-4 py-2 rounded text-white"
        style="background-color: var(--app-delete-color); border: none;"
        class:hover:bg-[var(--app-delete-hover-color)]={true}
      >
        🗑️
      </button>
      {#if callToAction}
        <button
          on:click={onCallToAction}
          class="px-4 py-2 rounded"
          class:bg-[var(--app-primary-color)]={true}
          class:hover:bg-[var(--app-primary-hover-color)]={true}
          class:text-white={true}
        >
          {callToAction}
        </button>
      {/if}
      {#if reply}
        <button
          on:click={onReply}
          class="px-4 py-2 rounded"
          class:bg-[var(--app-primary-color)]={true}
          class:hover:bg-[var(--app-primary-hover-color)]={true}
          class:text-white={true}
        >
          Reply
        </button>
      {/if}
    </div>
  </div>
  